import React from "react";
import { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import joi from "joi";
import axios from "axios";
import api from "../config.json";
import swal from "sweetalert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Table from "../../src/Common/table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, } from "@fortawesome/free-solid-svg-icons";
import _, { has, startCase } from "lodash";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../utill/LoadingComponent";
import { DatePicker, Space, Tooltip } from "antd";
import { Select } from 'antd';
import moment from "moment";
import QRCodeScanner from "../Common/QRCodeScanner";
import PaginationComponent from "../Common/PaginationComponent";

const schema = {
  PartNumber: joi.string().required().label("PartName"),
  MoldId: joi.string().required().label("MoldId"),
  RequestType: joi.string().required().label("RequestType"),
  Description: joi.string().required().label("Description"),
};

const EditInspection = ({ config, DisplayTitle, ButtonRedirect, RightName, getRightsForAccess, Heading, Inspections, userRights }) => {
  const ref = useRef(null);
  const ref1 = useRef(null);
  const history = useHistory();
  const [errors, seterrors] = useState("");
  const [startScann, setStartScann] = useState(false);
  const [querySuccess, setquery] = useState(false);
  const [datafromoutercomponent, setdatafromoutercomponent] = useState([]);
  const [inputData, setInputData] = useState({ DateTime: new Date() })
  const [templateList, setTemplateList] = useState([])
  const [InputData, setinputData] = useState([]);
  const [MoldList, setMoldList] = useState([]);
  const [types, setAllTypes] = useState([]);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [TotalPage, setTotalPage] = useState(5);
  const [PageSize, setPageSize] = useState(25);
  const [Date1, setDate] = useState({ From: "2024/1/8", Till: new Date() });
  const [ChecksheetType, setChecksheetType] = useState('')

  const [sortColumn, setSortColumn] = useState({
    path: "check_sheet_type",
    order: "asc",
  });


  const [SrStatus, setSrStatus] = useState("");
  const [parts, setAllParts] = useState([]);
  const [Item, setAllItem] = useState([]);
  const [Items, setAllItems] = useState([]);
  const [inspectionList, setInspectionList] = useState([])



  const { RangePicker } = DatePicker;
  useEffect(() => {
    setquery(true)
    axios
      .get(api.api + "customInspection")
      .then((result) => {
        setquery(false)
        setInspectionList(result.data);
      })
      .catch((err) => {
        setquery(false)
        console.log(err);
      })
  }, [])


  const handleOnChange = (name, value) => {
    const obj = { ...inputData }
    obj[name] = value;
    let all;
    if (name === 'Customer') {
      all = Item.filter(item => value === item.CustomerName && item.Inspection.some(x => x.Enable && x.InspectionName == inputData.InspectionType));
      // all = Item.filter(item=>item.CustomerName === value[0])
      const result = all.map(item => {
        return {
          label: item.ItemName,  // Override or add the label property
          value: item.ItemName,  // Override or add the value property
          ...item,  // Spread the original properties first
        };
      });
      const unique = [];
      const names = new Set();

      for (const item of result) {
        if (!names.has(item.ItemName)) {
          names.add(item.ItemName);
          unique.push(item);
        }
      }
      setAllTypes(unique)
      if (unique && unique.length == 1) {
        obj['ItemName'] = unique[0].label;
        setInputData(obj)
        all = Item.filter(item => obj.Customer == item.CustomerName && item.Inspection.some(x => x.Enable && x.InspectionName == inputData.InspectionType));
        // all = types.filter(item=>item.ItemName=== value[0])
        const result = all.map(item => {
          return {
            ...item,  // Spread the original properties first
            label: item.ItemNumber,  // Override or add the label property
            value: item.ItemNumber   // Override or add the value property
          };
        });
        const unique1 = [];
        const names = new Set();

        for (const item of result) {
          if (!names.has(item.ItemNumber)) {
            names.add(item.ItemNumber);
            unique1.push(item);
          }
        }
        console.log(unique, "cdsucsduc", unique1, all, obj.Customer)
        if (unique1 && unique1.length === 1) {

          setAllItems(unique1)
          all = Item.filter(item => obj.Customer == item.CustomerName && item.Inspection.some(x => x.Enable && x.InspectionName == inputData.InspectionType));
          // all = types.filter(item=>item.ItemName=== value[0])
          const result = all.map(item => {
            return {
              ...item,  // Spread the original properties first
              label: item.ItemNumber,  // Override or add the label property
              value: item.ItemNumber   // Override or add the value property
            };
          });
          const unique2 = [];
          const names = new Set();

          for (const item of result) {
            if (!names.has(item.ItemNumber)) {
              names.add(item.ItemNumber);
              unique2.push(item);
            }
          }
          setAllItems(unique2)
          console.log(unique2, "vsdvfvdv")
          if (unique2 && unique2.length == 1) {
            obj['ItemNumber'] = unique2[0].label;
            setInputData(obj)

          }
        }
      }
    } else if (name === 'ItemName') {
      all = Item.filter(item => value === item.ItemName && inputData.Customer == item.CustomerName && item.Inspection.some(x => x.Enable && x.InspectionName == inputData.InspectionType));
      // all = types.filter(item=>item.ItemName=== value[0])
      const result = all.map(item => {
        return {
          ...item,  // Spread the original properties first
          label: item.ItemNumber,  // Override or add the label property
          value: item.ItemNumber   // Override or add the value property
        };
      });
      const unique = [];
      const names = new Set();

      for (const item of result) {
        if (!names.has(item.ItemNumber)) {
          names.add(item.ItemNumber);
          unique.push(item);
        }
      }
      setAllItems(unique)
      console.log(unique, "vsdvfvdv")
      if (unique && unique.length == 1) {
        obj['ItemNumber'] = unique[0].label;
        setInputData(obj)
      }

    } else if (name === 'ItemNumber') {
      // all =  Items.filter(item => value.some(one => one === item.ItemNumber));

      all = Items.filter(item => inputData.Customer == item.CustomerName
        && value === item.ItemNumber && inputData.ItemName == item.ItemName && item.Inspection.some(x => x.Enable && x.InspectionName == inputData.InspectionType))

      console.log(all, "vsfouvhsdvl")
    }

    if (name == "InspectionType") {
      // const obj = { ...inputData }
      obj.Customer = ""
      obj.ItemName = ""
      obj.ItemNumber = ""
      obj.Operation = ""


    }
    if (name == "Customer") {
      obj.ItemName = ""
      obj.ItemNumber = ""
      obj.Operation = ""
    }
    if (name == "ItemName") {
      obj.ItemNumber = ""
      obj.Operation = ""
    }
    if (name == "ItemNumber") {
      obj.Operation = ""
    }

    setInputData(obj);
    console.log(obj);
  }
  useEffect(() => {
    getAllDropDownData();

  }, [DisplayTitle])

  useEffect(() => {
    if (inputData.InspectionType) {
      if (parts.length == 1 && !inputData.Customer) {
        handleOnChange("Customer", parts[0].value)

      }
      if (types.length == 1 && !inputData.ItemName) {
        handleOnChange("ItemName", types[0].value)

      }
      if (Items.length == 1 && !inputData.ItemNumber) {
        handleOnChange("ItemNumber", Items[0].value)

      }
      if (getOperations().length == 1 && !inputData.Operation) {
        handleOnChange("Operation", getOperations()[0].value)

      }
    }

    if (inputData.InspectionType && inputData.Customer && inputData.ItemName && inputData.ItemNumber) {
      if (getOperations(inputData).length == 1 && !inputData.Operation) {
        handleOnChange("Operation", getOperations(inputData)[0].value)

      }
    }


  }, [inputData, types, parts, Items])



  useEffect(() => {
    Heading(DisplayTitle)
    setInputData({ DateTime: new Date() })
  }, [DisplayTitle])


  const getOperations = (obj) => {
    const inputObj = { ...obj }
    const items = [...Item]
    let operations = items.filter(x => inputObj.Customer == x.CustomerName && inputObj.ItemName == x.ItemName && inputObj.ItemNumber == x.ItemNumber
      && x.Inspection.some(a => a.Enable && a.InspectionName == inputData.InspectionType))
    operations = operations.map(x => { return { label: x.Operation, value: x.Operation } })
    operations = _.uniqBy(operations, 'value')
    return operations
  }

  const getInspection = () => {
    const list = [...inspectionList]
    let arr = []
    list.filter(x => {
      if (getRightsForAccess(
        "DynamicDataRights",
        x.InspectionType,
        "write"
      )) {
        arr.push({ label: x.InspectionType, value: x.InspectionType })
      }
    })
    arr = _.uniqBy(arr, 'value')
    return arr
  }



  const getAllDropDownData = () => {
    axios.get(api.api + "item")
      .then((result) => {
        // result.data = result.data.filter(x => {
        //   const isHaveCheckSheet = x.Inspection.find(check => check.InspectionName == ChecksheetType && check.Enable)
        //   if (isHaveCheckSheet && isHaveCheckSheet.checkSheetTitle) {
        //     return x
        //   }
        // })
        const all = result.data.map((item) => ({
          label: item.CustomerName,
          value: item.CustomerName,
          ...item
        }));

        const unique = [];
        const names = new Set();

        for (const item of all) {
          if (!names.has(item.CustomerName)) {
            names.add(item.CustomerName);
            unique.push(item);
          }
        }
        console.log(result.data, "wsivbfisd", all, unique)

        setAllItem(result.data)
        setAllParts(unique)
        setAllTypes([])
        setAllItems([])

      })
      .catch((err) => {
        console.log(err, "Error")
      })


  }



  const columns = [
    { path: "DateTime", label: "Date", content: (obj) => <React.Fragment><label>{moment(obj.DateTime).format("DD-MM-YY HH:mm a")}</label><br /></React.Fragment> },
    { path: "Item", label: "Item Name" },
    { path: "InspectionType", label: "Inspection Type" },
    { path: "OkParts", label: "Ok Parts" },
    { path: "QtyToInspect", label: "Qty to Inspect" },
    { path: "QtyInspected", label: "Qty Inspected" },



    // { path: "check_sheet_title", label: "Check Sheet Title",  content: (obj) => (
    //   <React.Fragment>
    //     {console.log(obj,"crfbcrfbcrbhrfc")}
    // {obj.check_sheet_title.map(item=>item.Title).join(' , ')}
    //   </React.Fragment>
    // ), },
    // // { path: 'Description', label: 'Description'},
    // {
    //   path: "StateName",
    //   label: "Current State",
    //   content: (obj) => (
    //     <React.Fragment>
    //       <button
    //         style={{
    //           border:
    //             obj.StateName !== "Close"
    //               ? "1px solid #86d486"
    //               : "1px solid #ff9393",
    //           color: obj.StateName !== "Close" ? "green" : "red",
    //           background: obj.StateName !== "Close" ? "#def1de" : "#fee5e5",
    //           fontSize: "14px",
    //         }}
    //         className="rounded-4 m-0 px-2 py-1"
    //       >
    //         {obj.StateName}
    //       </button>
    //     </React.Fragment>
    //   ),
    // },

    // {
    //   key: "createdAt",
    //   label: "Created Date",
    //   content: (obj) => (
    //     <React.Fragment>
    //       <label>{obj.createdAt.split("T")[0]}</label>

    //       <br />
    //     </React.Fragment>
    //   ),
    // },

    // {
    //   key: "updatedAt",
    //   label: "Last Updated Date",
    //   content: (obj) => (
    //     <React.Fragment>
    //       <label>{obj.createdAt.split("T")[0]}</label>

    //       <br />
    //     </React.Fragment>
    //   ),
    // },
    {
      key: "add",
      content: (obj) => (
        getRightsForAccess( "DynamicDataRights",
            "EditReport",
            "update") &&  <React.Fragment>
          {["Closed"].includes(obj.State) ? (
            <Tooltip placement="top" title={'Update Entry'}>
              <FontAwesomeIcon onClick={() => handelEditRedirect(obj)} className="cursor-pointer" color="#007bff" icon={faEdit} />
              {/* <Link
                // to={{
                //   pathname: ButtonRedirect,
                //   state: { data: obj.LUID, obj: obj }, // Pass the data as state
                // }}
              >
              
                <button
              onClick={() => console.log(obj, "cdsiyvcsu ")}
              type="button"
              style={{ border: "none" }}
              disabled={obj.StateName === "Close" ? true : false}
              className="btn "
            >
                
            </button>
              </Link> */}
            </Tooltip>

          ) : null}
        </React.Fragment>

      ),
    },


  ];

  const handleGetData = () => {
    setquery(true);
    axios.put(api.api + "checkSheetDataEntryByQuery", { query: { InspectionType: ChecksheetType, Item: inputData.ItemName, ItemNumber: inputData.ItemNumber, Operation: inputData.Operation }, PageSize: PageSize, Page: CurrentPage })
      .then((result) => {
        if (result.status == 200) {
          // const filter = result.data.filter(item => item.InspectionType == ChecksheetType)
          // console.log(result.data, "fdvduhhivfb", filter);
          setTotalPage(Math.ceil(result.data.totalDocuments / PageSize));
          setinputData(result.data.data);
          setquery(false);
        }
      })
      .catch((err) => {
        toast.success(`${err}`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            backgroundColor: "red",
            color: "white",
          },
        });
        setquery(false);
      });
  }

  useEffect(() => {
    if (inputData.InspectionType && inputData.Customer && inputData.ItemName && inputData.ItemNumber && inputData.Operation) {
      handleGetData()
    }
  }, [CurrentPage, ChecksheetType, PageSize, inputData]);



  const handleSort = (sortColumn) => {
    if (InputData.length > 0) {
      const sorted = _.orderBy(
        InputData,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);
      setInputData(sorted);
    }
  };

  console.log(datafromoutercomponent, "isdbvibf");
  const returnValue = (data, type, Name) => {
    const keys = Object.keys(data); // Extract keys from the data object
    const values = Object.values(data); // Extract values from the data object
    // Create a new object with the existing data from outer component
    // and add/update the new key-value pair
    console.log(keys, values, "input filed values ");
    if (keys[0] === "PartNumber") {
      SendPartNumber(values[0]);
    }
    const newData = {
      ...datafromoutercomponent,
      [keys[0]]: values[0], // Assuming there's only one key-value pair in the data object
    };

    // Update the outer component data
    setdatafromoutercomponent(newData);

    return newData;
  };
  const SendPartNumber = (partnumber) => {
    setquery(true);

    axios
      .put(api.api + "getMouldIDs", { id: partnumber })
      .then((result) => {
        if (result.status == 200) {
          console.log(result.data, "Mould Id Request");
          setMoldList(result.data);
          setquery(false);
        } else {
          swal("Unable to submit data");
          setquery(false);
        }
      })
      .catch((err) => {
        toast.success(`${err}`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            backgroundColor: "green",
            color: "white",
          },
        });
        setquery(false);

        swal(`${err}`);
      });
  };



  // Function to handle changes in the input field

  const SelectedDates = (dates) => {
    console.log("Selected dates", dates);
    if (dates) {
      setDate({
        From: dates[0].format("YYYY-MM-DD"),
        Till: dates[1].format("YYYY-MM-DD"),
      });
    }
  };
  const handelGetSR = () => {
    setquery(true);

    axios
      .put(api.api + "MouldUnloadingDataEntry", {
        PageSize: PageSize,
        Page: CurrentPage,
        From: Date1.From,
        Till: Date1.Till,
      })
      .then((result) => {
        if (result.status == 200) {
          console.log(
            {
              PageSize: PageSize,
              Page: CurrentPage,
              From: Date1.From,
              Till: Date1.Till,
            },
            "fdgdfvdfvfvduhhivfb",
            result.data
          );
          setTotalPage(result.data.count);
          setInputData(result.data.data);
          setquery(false);
        }
      })
      .catch((err) => {
        toast.success(`${err}`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            backgroundColor: "red",
            color: "white",
          },
        });
        setquery(false);

        swal(`${err}`);
      });
  };
  const handelRedirect = () => {
    if (inputData.Customer && inputData.ItemName && inputData.ItemNumber && inputData.Operation && inputData.InspectionType) {
      const filteredItems = Item.filter(Item => Item.ItemName === inputData.ItemName && Item.ItemNumber === inputData.ItemNumber && Item.Operation === inputData.Operation);
      if (filteredItems.length > 0) {
        if (filteredItems[0]) {
          const inspection = filteredItems[0].Inspection.find(x => x.InspectionName == ChecksheetType)
          const config1 = inspectionList.find((x) => x.InspectionType == ChecksheetType)
          if (config1 && config1.ContinousDataEntry == "enable" && inspection.NumOfSamples > 1) {
            swal({
              title: "Alert!",
              text: `${inspection.InspectionName} is configured in 'Continuous Data Entry' model. Hence, sample size cannot be greater than 1. Inspection Quantity is set to ${inspection.NumOfSamples}. Kindly update this to use 'Continuous Data Entry' mode.`,
              icon: "warning",
              buttons: {
                cancel: {
                  text: "Cancel",
                  value: null,
                  visible: true,
                  className: "btn-secondary",
                  closeModal: true,
                },
                confirm: {
                  text: "Proceed",
                  value: true,
                  visible: true,
                  className: "btn-danger",
                  closeModal: true
                }
              }
            }).then((willDelete) => {
              if (willDelete) {
                // Action for the confirm button
                history.push(ButtonRedirect, { config: config1, obj: inputData, item: filteredItems[0], ChecksheetType: ChecksheetType });
              } else {
              }
            });

          } else {
            history.push(ButtonRedirect, { config: config1, obj: inputData, item: filteredItems[0], ChecksheetType: ChecksheetType });
          }
        }


      } else {
        swal('No items found with the specified ItemNumber');
      }
    } else {
      swal('Please select all inputs');
    }
  };


  const handelEditRedirect = (obj) => {
    const filteredItems = Item.filter(Item => Item.ItemName === obj.Item && Item.ItemNumber === obj.ItemNumber && Item.Operation === obj.Operation);
    if (filteredItems.length > 0) {
      if (filteredItems[0]) {
        const inspection = filteredItems[0].Inspection.find(x => x.InspectionName == ChecksheetType)
        const config1 = inspectionList.find((x) => x.InspectionType == ChecksheetType)
        if (config1 && config1.ContinousDataEntry == "enable" && inspection.NumOfSamples > 1) {
          swal({
            title: "Alert!",
            text: `${inspection.InspectionName} is configured in 'Continuous Data Entry' model. Hence, sample size cannot be greater than 1. Inspection Quantity is set to <number>. Kindly update this to use 'Continuous Data Entry' mode.`,
            icon: "warning",
            buttons: {
              cancel: {
                text: "Cancel",
                value: null,
                visible: true,
                className: "btn-secondary",
                closeModal: true,
              },
              confirm: {
                text: "Proceed",
                value: true,
                visible: true,
                className: "btn-danger",
                closeModal: true
              }
            }
          }).then((willDelete) => {
            if (willDelete) {
              // Action for the confirm button
              history.push(ButtonRedirect, { action: "edit", config: config1, obj: obj, item: filteredItems[0], ChecksheetType: ChecksheetType });
            } else {
            }
          });

        } else {
          history.push(ButtonRedirect, { action: "edit", config: config1, obj: obj, item: filteredItems[0], ChecksheetType: ChecksheetType });
        }
      }


    } else {
      swal('No items found with the specified ItemNumber');
    }
  };

  const getQRCodeString = (string) => {
    setStartScann(string);
    alert(string)
  }
  return (
    <div>
      {querySuccess ? <Loading /> : ""}

      {/* <div className="text-center heading-bg mb-4">
        <h4 className="text-white p-0 m-0">{DisplayTitle}</h4>
      </div> */}

      <ToastContainer />
      <div className="row">
        <div className='col-sm-3 mt-4'>
          <label>Inspection Type</label>
          <Select
            showSearch
            maxTagCount='responsive'
            // mode="multiple"
            placeholder="Select Inspection"
            value={inputData.InspectionType || []}
            onChange={(values) => {
              setChecksheetType(values)
              handleOnChange('InspectionType', values)
            }}
            style={{ width: '100%' }}
            options={getInspection()}
          />
        </div>
        <div className='col-sm-3 my-4'>
          <label>Customer</label>
          <Select
            // maxTagCount='responsive'
            // mode="multiple"
            showSearch
            placeholder="Select Customer"
            value={inputData.Customer || []}
            onChange={(values) => {
              handleOnChange('Customer', values)
            }}
            style={{ width: '100%' }}
            options={parts}
          />
        </div>
        <div className='col-sm-3 my-4'>
          <label>Item Name</label>

          <Select
            showSearch
            maxTagCount='responsive'
            // mode="multiple"
            placeholder="Select item name"
            value={inputData.ItemName || []}
            onChange={(values) => {
              handleOnChange('ItemName', values)
            }}
            style={{ width: '100%' }}
            options={types}
          />
        </div>
        <div className='col-sm-3 my-4'>
          <label>Item Number</label>

          <Select
            showSearch
            maxTagCount='responsive'
            // mode="multiple"
            placeholder="Select Item Number"
            value={inputData.ItemNumber || []}
            onChange={(values) => {
              handleOnChange('ItemNumber', values)
            }}
            style={{ width: '100%' }}
            options={Items}
          />
        </div>
        <div className='col-sm-3 mt-1'>
          <label>Operation</label>
          <Select
            showSearch
            maxTagCount='responsive'
            // mode="multiple"
            placeholder="Select Operation"
            value={inputData.Operation || []}
            onChange={(values) => {
              handleOnChange('Operation', values)
            }}
            style={{ width: '100%' }}
            options={getOperations(inputData)}
          />
        </div>

        <div className="col-sm-2 my-1">
          <button
            className="btn-sm btn-primary  shadow "
            style={{ marginTop: '29px' }}
            onClick={() => handleGetData()}
          >
            Get Report
          </button>
        </div>
        {/* <div className="col-sm-2 my-1">
          <button
            className="btn-sm btn-primary  shadow "
            style={{ marginTop: '29px' }}
            onClick={() => handelRedirect()}
          >
            Start Inspection
          </button>
        </div> */}
        {/* <div className="col-sm-2 my-4">
          <button
            className="btn-sm btn-primary  shadow "
            style={{ marginTop: '29px' }}
            onClick={() => setStartScann(true)}
          >
            OR Scan 
          </button>
        </div> */}
      </div>
      {/* {startScann && <QRCodeScanner isScann={startScann} setScanning={setStartScann} getQRCodeString={getQRCodeString} />} */}
      {/* <div className="d-flex mx-2">
        <div className="col-sm-3">
          <div className="form-group text-center d-flex flex-column">
            <label className="small">From - Till</label>
            <div className="">
              <Space direction="vertical" size={12}>
                <RangePicker onChange={SelectedDates} />
              </Space>
            </div>
          </div>
        </div>
        <div className="mx-2 my-4">
          <button
            className="btn btn-primary rounded-4 shadow"
            onClick={() => handelGetSR()}
          >
            Apply
          </button>
        </div>
        <div className="mx-2 my-4">
          <button
            className="btn btn-primary rounded-4 shadow"
            onClick={() => history.push(ButtonRedirect)}
          >
            Start {DisplayTitle}
          </button>
        </div>
      </div> */}

      <div className="p-2 mx-2 rounded-4 shadow">
        {InputData && InputData.length > 0 ? (
          <Table
            id="moldHistory"
            onSort={handleSort}
            columns={columns}
            sortColumn={sortColumn}
            data={InputData}
          />
        ) : (
          <Table
            id="mould-raw-material"
            onSort={handleSort}
            columns={columns}
            sortColumn={sortColumn}
            data={InputData}
          ></Table>
        )}
        <div className="float-end m-3">
          <PaginationComponent
                  current={CurrentPage}
                  pageSize={PageSize}
                  totalItems={TotalPage * PageSize}  // or just use total count
                  onPageChange={(page, size) => {
                    if (size !== PageSize) setCurrentPage(1);
                    else setCurrentPage(page);
                    setPageSize(size);
                  }}
                />
        </div>
      </div>
    </div>
  );
};

export default EditInspection;
